export default __webpack_public_path__ + "static/media/close.5dcb9c65.svg";